function formatLiteralDate (input, format) {
  if (!input) return 'Sin fecha'
  const iso = String(input)
  const [datePart, timePart = '00:00:00'] = iso.split('T')
  if (!datePart) return 'Fecha inválida'

  const [year, month, day] = datePart.split('-')
  const [hour = '00', minute = '00', second = '00'] = timePart.split(':')[0]
    ? timePart.split(':')
    : []

  const pad = n => n.toString().padStart(2, '0')

  const map = {
    YYYY: year,
    MM: pad(month),
    DD: pad(day),
    HH: pad(hour),
    mm: pad(minute),
    ss: pad(second.slice(0, 2))
  }

  return format.replace(/YYYY|MM|DD|HH|mm|ss/g, key => map[key])
}

export default {
  methods: {
    formatDate (date, format = 'YYYY-MM-DD') {
      if (!date) return 'Sin fecha'
      return formatLiteralDate(date, format)
    },
    formatDateTimestamp (date, format = 'YYYY-MM-DD HH:mm:ss') {
      if (!date) return 'Sin fecha'
      return formatLiteralDate(date, format)
    },
    formatDateTimestampHour (date, format = 'HH:mm:ss') {
      if (!date) return 'Sin hora'
      return formatLiteralDate(date, format)
    },
    numberFormat (amount = 0) {
      return new Intl.NumberFormat().format(amount)
    },
    formatCurrency (amount = 0, currency = 'MXN') {
      return new Intl.NumberFormat('es-MX', {
        style: 'currency',
        currency
      }).format(amount)
    }
  }
}
